import AttachmentActions from 'actions/attachment-actions';

function fetchRoles(teamId, opts = {}) {
  return AttachmentActions.fetchRoles(teamId, { searchTerm: opts.searchTerm, userId: opts.userId });
}

export default fetchRoles;
